import activity from 'src/i18n/de-DE/activity';
import agent from 'src/i18n/de-DE/agent';
import alarm from 'src/i18n/de-DE/alarm';
import app from 'src/i18n/de-DE/app';
import appointment from 'src/i18n/de-DE/appointment';
import changelog from 'src/i18n/de-DE/changelog';
import common from 'src/i18n/de-DE/common';
import contactInformation from 'src/i18n/de-DE/contactInformation';
import dailyActivity from 'src/i18n/de-DE/dailyActivity';
import document from 'src/i18n/de-DE/document';
import filter from 'src/i18n/de-DE/filter';
import genericList from 'src/i18n/de-DE/genericList';
import ido from 'src/i18n/de-DE/ido';
import idoContactPerson from 'src/i18n/de-DE/idoContactPerson';
import login from 'src/i18n/de-DE/login';
import mail from 'src/i18n/de-DE/mail';
import main from 'src/i18n/de-DE/main';
import memo from 'src/i18n/de-DE/memo';
import menu from 'src/i18n/de-DE/menu';
import message from 'src/i18n/de-DE/message';
import note from 'src/i18n/de-DE/note';
import phoneCall from 'src/i18n/de-DE/phoneCall';
import settings from 'src/i18n/de-DE/settings';
import setupWizard from 'src/i18n/de-DE/setupWizard';
import share from 'src/i18n/de-DE/share';
import spotlight from 'src/i18n/de-DE/spotlight';
import status from 'src/i18n/de-DE/status';
import tabManager from 'src/i18n/de-DE/tabManager';
import task from 'src/i18n/de-DE/task';
import timer from 'src/i18n/de-DE/timer';
import userOnline from 'src/i18n/de-DE/userOnline';
import userState from 'src/i18n/de-DE/userState';
import workspace from 'src/i18n/de-DE/workspace';
import workspaceTabs from 'src/i18n/de-DE/workspaceTabs';

export default {
	...activity,
	...agent,
	...alarm,
	...app,
	...appointment,
	...changelog,
	...common,
	...contactInformation,
	...dailyActivity,
	...document,
	...filter,
	...genericList,
	...login,
	...ido,
	...idoContactPerson,
	...mail,
	...main,
	...memo,
	...menu,
	...message,
	...note,
	...phoneCall,
	...settings,
	...setupWizard,
	...share,
	...spotlight,
	...status,
	...tabManager,
	...task,
	...timer,
	...userOnline,
	...userState,
	...workspace,
	...workspaceTabs,
};
